import { Inject, Injectable, NgZone } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LoginService } from './login.service';
import { Idle, DEFAULT_INTERRUPTSOURCES, AutoResume } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { MatIconRegistry } from '@angular/material/icon';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ADPResourceService, StorageService } from 'digital-core';
import { SessionTimeoutModalWindowComponent } from 'src/app/shared/components/session-timeout-modal-window/session-timeout-modal-window.component';
import OktaAuth from '@okta/okta-auth-js';
import { OKTA_AUTH } from '@okta/okta-angular';


@Injectable({
  providedIn: 'root'
})
export class SessionManagementService {
  idleState: string;
  dialogRef: any;
  public isLogout = false;
  modalData: any = {};
  isActive = false;

  constructor(
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
    public resourceService: ADPResourceService,
    public domSanitizer: DomSanitizer,
    public matIconRegistry: MatIconRegistry,
    private idle: Idle,
    private keepalive: Keepalive,
    private matDialog: MatDialog,
    private router: Router
  ) {
  }


  configureSessionTimeOut() {
    this.idle.setTimeout(
      Number(
       this.resourceService.getPortalSetting('Session_WarningTimeOut').Value
      )
    );

    this.idle.setIdle(
      Number(this.resourceService.getPortalSetting('Session_IdleTime').Value)
    );

    // setting the events that will wake up the aplication from iddle
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.setAutoResume(AutoResume.notIdle);

    // notify if the user is back from idle
    this.idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.';
      if (this.dialogRef) {
        this.matDialog.closeAll();
      }
    });

    // notify if the session expires
    this.idle.onTimeout.subscribe(() => {
      if (this.dialogRef) {
        this.matDialog.closeAll();
      }
      this.idleState = 'Timed out!';
      this.logOff();
    });

    // will notify once the user is iddle
    this.idle.onIdleStart.subscribe(() => {
      this.setWarning();
    });

    // showing the warning dialog if the session is about to expire.
    this.idle.onTimeoutWarning.subscribe(countdown => {
      this.increaseWarningCountDown(countdown);
    });

    // keeping alive the token
    /* Not used for now
    this.keepalive.interval(
      Number(
        //this.resourceService.getPortalSetting('Session_TokenRefreshInterval').Value
      )
    );
    this.keepalive.onPing.subscribe(async () => {
      }
    );
    */
    this.resetIdleState();
  }

  resetIdleState() {
    this.idle.watch();
    this.idleState = 'Started.';
    // this.timedOut = false;
  }
  increaseWarningCountDown(count: number) {
    const body = (this.modalData.Body = this.resourceService.getViewLabel(
      'Global_Timeout_Body'
    ));

    this.modalData.body = body.replace('{Key_Seconds}', count.toString());
  }

  setWarning() {
    if(!this.isActive) {
        if(localStorage.getItem('okta-user') === null){
          return;
        }
        this.isActive = true;
        this.modalData.title = 'Global_Timeout_Title';
        this.modalData.body = this.resourceService.getViewLabel(
          'Global_Timeout_Body'
        ).replace('{Key_Seconds}', this.resourceService.getPortalSetting('Session_WarningTimeOut').Value);

        this.modalData.buttonContinueText = 'Global_ContinueSession';
        this.modalData.buttonEndText = 'Global_EndSession';

        this.dialogRef = this.matDialog.open(SessionTimeoutModalWindowComponent, {
          data: this.modalData
        });

        this.dialogRef.afterClosed().subscribe(async result => {
          this.isActive = false;
          if (result && result.toLowerCase() === 'yes') {
            this.matDialog.closeAll();
            this.logOff();
          } else {
            this.idle.watch();
            this.dialogRef.close();
            this.matDialog.closeAll();
            const renewToken = await this.oktaAuth.token.renewTokens();
            await this.oktaAuth.tokenManager.setTokens(renewToken);
          }
        });
    }
  }

  logOff() {
    this.router.navigate(['/logout']);

  }


}
